import { Challenge } from '@/features/journeys'
import { cn } from '@/shared/lib/utils'

interface DescriptionProps {
  challenge?: Challenge
  className?: string
}

export const Description = ({ challenge, className }: DescriptionProps) => {
  if (!challenge) return null

  const { meta } = challenge

  const hasDescription = !!challenge.description
  const hasSubtitle = !!meta?.subtitle
  let icon = `/icons/journeys/${challenge.kind}.svg`
  if (challenge.kind == 'question')
    icon = `/icons/journeys/${challenge.kind}_${meta?.question_kind}.svg`

  if (!hasDescription && !hasSubtitle) return null
  return (
    <span
      className={cn(
        'p-4 rounded-lg bg-jacaranda/20 flex flex-col items-start gap-2 w-full',
        className
      )}
    >
      <div className="flex gap-2">
        <img src={icon} alt="" className="size-10 -m-[5px] object-cover" />
        <span className="text-lg font-semibold">{meta?.subtitle}</span>
      </div>
      <div className="text-md font-semibold text-gray-700">
        {challenge.description}
      </div>
    </span>
  )
}
